import { createBrowserRouter, RouterProvider } from "react-router-dom";
import PwReset from "./Components/PwReset";
import RootLayout from "./Components/Root/Root";
import ScheinListe from "./Components/ScheinListe";
import ErrorPage from "./Pages/ErrorPage/ErrorPage";
import HomePage from "./Pages/HomePage/HomePage";
import LoginPage from "./Pages/LoginPage/LoginPage";
import ServicescheinOverviewPage from "./Pages/Serviceschein/Serviceschein";
import { AuthProvider } from "./Store/auth-context";
import { ScheinProvider } from "./Store/schein-context";
import { UIProvider } from "./Store/ui-context";
// import DeviceOrientation, { Orientation } from 'react-screen-orientation'

const router = createBrowserRouter([
  {
    path: "/",
    element: <RootLayout />,
    errorElement: <ErrorPage />,
    children: [
      { index: true, path: "/", element: <ServicescheinOverviewPage /> },
      {
        path: "/uebersicht",
        element: <HomePage />,
        errorElement: <ErrorPage />,
      },
      { path: "/login", element: <LoginPage />, errorElement: <ErrorPage /> },
      {
        path: "/scheine",
        element: <ScheinListe />,
        errorElement: <ErrorPage />,
      },
      {
        path: "/PasswortZuruecksetzen",
        element: <PwReset />,
        errorElement: <ErrorPage />,
      },
    ],
  },
]);

const App = () => {
  return (
    // <DeviceOrientation lockOrientation={"portrait"}>
    <AuthProvider>
      <ScheinProvider>
        <UIProvider>
          <RouterProvider router={router} />
        </UIProvider>
      </ScheinProvider>
    </AuthProvider>
    // </DeviceOrientation>
  );
};

export default App;
